import React from "react";
import { statusKurbanBadge } from "../../KurbanUIHelpers";

export function StatusKurban(cellContent, row) {
  let value = statusKurbanBadge(cellContent);
  return (
    <span className={`label label-lg label-light-${value.type} label-inline`}>
      {value.text}
    </span>
  );
}
